import React, { useState } from "react";
import styled from "styled-components";
import { Repeater, types } from "react-bricks/frontend";
import { InfoCardProps } from "../cards/InfoCard";
import { color } from "styles/colours";
import {
  VerticalPadding,
  VerticalPaddingWrapper,
  verticalPadSideProp,
} from "../utils/verticalPadding";
import TextHeading from "../common/TextHeading";

interface PressKitSectionProps {
  background?: types.IColor;
  gap: number;
  cardHeightOffset?: number;
  cards: types.RepeaterItems<InfoCardProps>;
  paddingVertical?: VerticalPadding;
  imageType: "icon" | "cover" | "none";
  size?: "s" | "m";
  heading?: types.TextValue;
  textAlign: "left" | "center";
  showDate: boolean;
}

export const PressKitSection: types.Brick<PressKitSectionProps> = ({
  cards,
  gap,
  background,
  paddingVertical,
  imageType,
  cardHeightOffset = 0,
  size = "m",
  textAlign,
  showDate,
}) => {
  const [visibleCount, setVisibleCount] = useState(6);

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 6);
  };

  const hasMore = cards.length > visibleCount;

  return (
    <VerticalPaddingWrapper paddingVertical={paddingVertical} backgroundColor={background?.color}>
      <Wrapper>
        <InfoCardsWrapper gap={gap} visibleCount={visibleCount}>
          <Repeater
            propName="cards"
            itemProps={{ imageType, size, cardHeightOffset, textAlign, showDate }}
          />
        </InfoCardsWrapper>
        {hasMore && (
          <ShowMoreWrapper>
            <ShowMoreButton onClick={handleShowMore}>Show more</ShowMoreButton>
          </ShowMoreWrapper>
        )}
      </Wrapper>
    </VerticalPaddingWrapper>
  );
};

PressKitSection.schema = {
  name: "press-kit-section",
  label: "Press Kit Section",
  category: "Product Cards Components",
  previewImageUrl: "/static/bricks/presskit-section.png",
  // Define repeaters for child bricks
  repeaterItems: [
    {
      name: "cards",
      itemType: "info-card",
      itemLabel: "Info Cards",
      min: 1,
      max: 30,
    },
  ],
  // Define default props
  getDefaultProps: () => ({
    background: { color: color.white },
    gap: 2,
    paddingVertical: "s",
    cardHeightOffset: 0,
    size: "s",
    imageType: "cover",
    textAlign: "left",
    showDate: true,
    cards: [
      {
        title: "Title",
        content:
          "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla.",
        hasLink: true,
        linkText: "Learn more",
        linkUrl: "#",
        imageType: "cover",
        showDate: true,
        textAlign: "left",
      },
      {
        title: "Title",
        content:
          "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla.",
        hasLink: true,
        linkText: "Learn more",
        linkUrl: "#",
        imageType: "cover",
        showDate: true,
        textAlign: "left",
      },
      {
        title: "Title",
        content:
          "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla.",
        hasLink: true,
        linkText: "Learn more",
        linkUrl: "#",
        imageType: "cover",
        showDate: true,
        textAlign: "left",
      },
      {
        title: "Title",
        content:
          "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla.",
        hasLink: true,
        linkText: "Learn more",
        linkUrl: "#",
        imageType: "cover",
        showDate: true,
        textAlign: "left",
      },
      {
        title: "Title",
        content:
          "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla.",
        hasLink: true,
        linkText: "Learn more",
        linkUrl: "#",
        imageType: "cover",
        showDate: true,
        textAlign: "left",
      },
      {
        title: "Title",
        content:
          "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla.",
        hasLink: true,
        linkText: "Learn more",
        linkUrl: "#",
        imageType: "cover",
        showDate: true,
        textAlign: "left",
      },
      {
        title: "Title",
        content:
          "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla.",
        hasLink: true,
        linkText: "Learn more",
        linkUrl: "#",
        imageType: "cover",
        showDate: true,
        textAlign: "left",
      },
      {
        title: "Title",
        content:
          "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla.",
        hasLink: true,
        linkText: "Learn more",
        linkUrl: "#",
        imageType: "cover",
        showDate: true,
        textAlign: "left",
      },
      {
        title: "Title",
        content:
          "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla.",
        hasLink: true,
        linkText: "Learn more",
        linkUrl: "#",
        imageType: "cover",
        showDate: true,
        textAlign: "left",
      },
    ],
  }),
  stories: [],
  // Define side edit props
  sideEditProps: [
    {
      name: "background",
      label: "Background Color",
      type: types.SideEditPropType.Select,
      shouldRefreshStyles: true,
      selectOptions: {
        display: types.OptionsDisplay.Color,
        options: [
          { label: "White", value: { color: color.white } },
          { label: "Gray", value: { color: color.B210 } },
          { label: "Purple", value: { color: color.S310 } },
        ],
      },
    },
    {
      name: "gap",
      label: "Gap",
      type: types.SideEditPropType.Number,
      shouldRefreshStyles: true,
    },
    {
      name: "size",
      label: "Size (width)",
      type: types.SideEditPropType.Select,
      shouldRefreshStyles: true,
      selectOptions: {
        display: types.OptionsDisplay.Radio,
        options: [
          { label: "Small", value: "s" },
          { label: "Medium", value: "m" },
        ],
      },
    },
    {
      name: "cardHeightOffset",
      label: "Adjust card height",
      type: types.SideEditPropType.Range,
      shouldRefreshStyles: true,
      rangeOptions: {
        min: -15,
        max: 15,
        step: 1,
      },
    },
    {
      name: "imageType",
      label: "Image type",
      type: types.SideEditPropType.Select,
      shouldRefreshStyles: true,
      selectOptions: {
        display: types.OptionsDisplay.Radio,
        options: [
          { label: "Icon", value: "icon" },
          { label: "Cover", value: "cover" },
          { label: "None", value: "none" },
        ],
      },
    },
    {
      name: "textAlign",
      label: "Text Align",
      type: types.SideEditPropType.Select,
      shouldRefreshStyles: true,
      selectOptions: {
        display: types.OptionsDisplay.Radio,
        options: [
          { label: "Left", value: "left" },
          { label: "Center", value: "center" },
        ],
      },
    },
    {
      name: "showDate",
      label: "Show Date?",
      type: types.SideEditPropType.Boolean,
      shouldRefreshStyles: true,
    },
    {
      name: "showHeading",
      label: "Show heading?",
      type: types.SideEditPropType.Boolean,
    },
    verticalPadSideProp,
  ],
};

export const InfoCardsWrapper = styled.section<{
  gap: number;
  visibleCount: number;
}>`
  display: grid;
  gap: ${(p) => p.gap}rem;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  max-width: calc(3 * 300px + 2 * ${(p) => p.gap}rem);
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  & > *:nth-child(n + ${({ visibleCount }) => visibleCount + 1}) {
    display: none;
  }
`;

const Wrapper = styled.div`
  padding: 0 5% 7.5rem;
`;

const ShowMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`;

const ShowMoreButton = styled.button`
  background: ${color.P100};
  color: ${color.white};
  font-size: 1rem;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background 0.2s ease;
`;
